
define('tpl!taoQtiTest/controller/creator/templates/itemref-props-weight', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"grid-row itemref-weight\">\n    <div class=\"col-9\">\n        <input data-bind=\"identifier\" data-validate=\"$notEmpty; $testIdFormat; $testIdAvailable(original=";
  if (helper = helpers.identifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.identifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + ");\" type=\"text\" value=\"";
  if (helper = helpers.identifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.identifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" />\n    </div>\n    <div class=\"col-2\">\n        <input data-bind=\"value\" data-validate=\"$notEmpty; $numeric;\" type=\"text\" value=\"";
  if (helper = helpers.value) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.value); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-bind-encoder=\"float\" />\n    </div>\n    <div class=\"col-1\">\n        <a class=\"itemref-weight-remove\" data-delete=\":parent .itemref-weight\">\n            <span class=\"icon-bin\"></span>\n        </a>\n    </div>\n</div>";
  return buffer;
  });
});

